import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';

import Protect from "../containers/Protect";
import Constants from "../utils/Constants";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

function ProtectRouter(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);
	let {updateHeader, resetHeader, showSnackbar, banner, bannerHeight,
			setBannerClassName, showBanner, hasNudgeBanner, history, setFullScreenClassName} = props,
		routes = ProtectRouter.getRoutes();

	return (
		<Switch>
			<Redirect
				exact
				from={routes[0]}
				to={routes[1]} />
			{AuthorizedUser.hasPeople(authenticatedUser) && false ?
				<Route
					path={routes[1]}
					render={renderProps =>
						<Protect
							{...renderProps}
							history={history}
							type={Constants.ENTITIES.IDS.PERSON}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							showBanner={showBanner}
							banner={banner}
							bannerHeight={bannerHeight}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[1]}
					to="/no-access" />
			}

			{AuthorizedUser.hasPlaces(authenticatedUser) && false ?
				<Route
					path={routes[2]}
					render={renderProps =>
						<Protect
							{...renderProps}
							history={history}
							type={Constants.ENTITIES.IDS.PLACE}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							showBanner={showBanner}
							banner={banner}
							bannerHeight={bannerHeight}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[2]}
					to="/no-access" />
			}

			{AuthorizedUser.hasEvents(authenticatedUser) && false ?
				<Route
					path={routes[3]}
					render={renderProps =>
						<Protect
							{...renderProps}
							history={history}
							type={Constants.ENTITIES.IDS.EVENT}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							showBanner={showBanner}
							banner={banner}
							bannerHeight={bannerHeight}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[3]}
					to="/no-access" />
			}
		</Switch>
	);
}

ProtectRouter.getRoutes = () => {
	const routes = [
		"/protect",
		"/protect/people",
		"/protect/places",
		"/protect/events"
	];
	return routes;
};

ProtectRouter.propTypes = {
	history: PropTypes.object.isRequired,
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
	showBanner: PropTypes.func,
	setBannerClassName: PropTypes.func,
	banner: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	bannerHeight: PropTypes.number,
	hasNudgeBanner: PropTypes.bool,
	setFullScreenClassName: PropTypes.func
};

export default ProtectRouter;